module.exports = __webpack_public_path__ + "img/logo.a1103ca2.png";